import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentosAuditoriaService {

  urlBase: string = environment.apiEndpoint;
  constructor(private httpClient: HttpClient) { }

  validarTokenSolicitud(idContratista, token) {
    return this.httpClient.get(`${this.urlBase}auditoria/valida-token/${idContratista}?token=${token}`);
  }

  datosContratista(idContratista, token) {
    return this.httpClient.get(`${this.urlBase}auditoria/datos-contratista/${idContratista}?token=${token}`);
  }

  enviarDatos(idContratista, rfc, form, idSolicitud, token) {
    let url = `${this.urlBase}auditoria/cargar-documentos/${idContratista}?rfc=${rfc}&solicitud=${idSolicitud}&token=${token}`;
    // console.log(token)
    // let httpHeaders = new HttpHeaders()
    //   .set('token', token);
    return this.httpClient.post(url, form /*,{ headers: httpHeaders }*/);
  }
}
